module.exports = __webpack_public_path__ + "img/burger.c30f40f1.svg";